import { Attributes } from '@leverege/ui-attributes';
import { Types } from "../../constants/index.js";
function defaultGetAttributes(target, extraFilter) {
  const attrs = Attributes.getAttributesFor(target?.type);
  const avail = attrs.filter(attr => {
    return attr?.source?.type === Types.apiName && (extraFilter ? extraFilter(attr) : true);
  });
  return avail;
}
function getSort(optionKey) {
  return function sort(a, b) {
    const as = a?.source?.[optionKey]?.formSort || 'z';
    const bs = b?.source?.[optionKey]?.formSort || 'z';
    return as.localeCompare(bs);
  };
}
export default {
  defaultGetAttributes,
  getSort
};